import React, { ReactNode } from 'react';
import { Link, Icon } from '@tcc/crate';
import cx from 'classnames';
import styles from './cardAndPreview.css';
import CardContent from './CardContent';

export interface CardProps {
  cardType?: string;
  children?: ReactNode;
  errorMessage?: string;
  icon?: string;
  iconClassName?: string;
  isLoading?: boolean;
  link?: string;
  onClickIcon?: () => void;
  onClickLink?: () => void;
  testId?: string;
  title: string;
  secondaryLink?: string;
  onClickSecondaryLink?: () => void;
  tooltip?: boolean;
}

export const Card = ({
  cardType,
  children,
  errorMessage,
  icon,
  iconClassName,
  onClickIcon,
  isLoading,
  link,
  onClickLink,
  title,
  testId,
  secondaryLink,
  onClickSecondaryLink
}: CardProps) => (
    <div className={styles.card} data-test-id={`${testId}-card`} data-card-type={cardType}>
      <div className={styles.cardTittle}>
        <h2 data-test-id={`${testId}-title`}>{title}</h2>
        {icon && (
          <Icon
            className={cx(styles.cardIcon, iconClassName)}
            glyph={icon}
            onClick={onClickIcon}
            testId={`${testId}-icon`}
          />
        )}
        {secondaryLink && onClickSecondaryLink &&
          // eslint-disable-next-line jsx-a11y/anchor-is-valid
          <Link
            className={styles.secondaryLink}
            onClick={onClickSecondaryLink}
            testId={`${testId}-secondary-link`}
          >
            {secondaryLink}
          </Link>
        }
      </div>
      <CardContent
        errorMessage={errorMessage}
        isLoading={isLoading}
        spinnerSize="50px"
      >
        {children}
      </CardContent>
      {link && (
        // eslint-disable-next-line jsx-a11y/anchor-is-valid
        <Link
          className={styles.link}
          onClick={onClickLink}
          testId={`${link}-link`}
        >
          {link}
        </Link>
      )}
    </div>
  );

export default Card;
